/*
 * Module for displaying unhandled javascript errors as well as console.log/.warn/.info/.log messages
 * in a user-visible console.
 */
rs.module("controls/diagnostics/scriptlog",

	// dependencies
	["common/perfect-scrollbar", "common/auto-scroll", "ui/framework/client-templates"],

	function (perfectScrollbar, autoscroll, clientTemplates) {
		const _logType = {
			error: 0,
			warn: 1,
			log: 2,
			info: 3
		};

		var _logContainer;
		var _typeDetail = {};
		var _onErrorCallbacks = [];

        // Initialize the menu
        function initialize(selectors, icons, templateKeys) {
			var control = $.js(selectors.scriptLog);

			_logContainer = $(control).js(selectors.dataContainer);

			// setup scrolling (perfect scrollbars and autoscrolling)
			var scrollContainer = $(control).js(selectors.scrollContainer);
			var scrollbars = perfectScrollbar.createInstance(scrollContainer);
			autoscroll.autoscroll(scrollContainer, () => scrollbars.update());

			// map log type to extra information
			_typeDetail[_logType.error] = { icon: icons.error, cssClass: "error", consoleFunction: console.error };
			_typeDetail[_logType.warn] = { icon: icons.warning, cssClass: "warning", consoleFunction: console.warn };
			_typeDetail[_logType.info] = { icon: icons.info, cssClass: "info", consoleFunction: console.info };
			_typeDetail[_logType.log] = { icon: icons.log, cssClass: "log", consoleFunction: console.log };

			// replace console.log
			console.log = function () {
				_writeMessage(arguments[0], _logType.log);
				_apply(_typeDetail[_logType.log].consoleFunction, arguments);
			};

			// replace console.info
			console.info = function () {
				_writeMessage(arguments[0], _logType.info);
				_apply(_typeDetail[_logType.info].consoleFunction, arguments);
			};

			// replace console.error
			console.error = function () {
				_writeMessage(arguments[0], _logType.error);
				_apply(_typeDetail[_logType.error].consoleFunction, arguments);

				invokeOnJsErrorCallbacks();
			};

			// replace console.warn
			console.warn = function () {
				_writeMessage(arguments[0], _logType.warn);
				_apply(_typeDetail[_logType.warn].consoleFunction, arguments);
			};

			// handle page errors
			window.onerror = function (msg, url, lineNo, columnNo, error) {
				_writeMessage(msg, _logType.error, error);

				invokeOnJsErrorCallbacks();

				// proceed to write to browser's console
                return false;
            };

			// Call an original function with supplied arguments
			function _apply(func, args) {
				func.apply(console, Array.from(args));
			}

			// write a message and type to the visible log
			function _writeMessage(message, type, error) {

				var basePath;
				if (!basePath) {
					var currenturl = window.location;
					basePath = currenturl.protocol + "//" + currenturl.host;
				}

				// render the new log line
				var element = $(clientTemplates.render(templateKeys.entry,
					{
						cssClass: _typeDetail[type].cssClass,
						iconName: _typeDetail[type].icon,
						message: message,
						isError: type === _logType.error
					}));

				if (type === _logType.error) {
					// get the UI block to contain the stack frames
					var frameContainer = $(element).js(selectors.stackContainer);

					// parse the stack into frames
					_parseStack(error, function (frame) {
						frame.fileName = frame.fileName.replace(basePath, '');

						// render the template for the stack frame
						var frameElement = $(clientTemplates.render(templateKeys.stack, frame));

						// add the frame
						$(frameContainer).append(frameElement);
					});
				}

				// add it to the log display
				_logContainer.append(element);
			}

			// Use stacktrace-js to parse the callstack and translate file paths
			// to their source js paths.
			function _parseStack(error, callback) {
				if (error) {
					StackTrace.fromError(error).then(frames => {
						frames.forEach(function (frame) {
							callback(frame);
						});
					});
                }
			}

			// Invoke any onJsError callbacks
			function invokeOnJsErrorCallbacks() {
				// execute each theme-changed callback that has been registered
				_onErrorCallbacks.forEach(function (callback) {
					callback.call(null);
				});
			}
        }

		// Add a callback to be fired when a javascript error occurs
		function onJsError(callback) {
			_onErrorCallbacks.push(callback);
		}

        var exports = {
			initialize: initialize,
			onJsError: onJsError
        };

        return exports;
    }
);